
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import PreferencesPanel from "@/components/PreferencesPanel.vue";
import WorkflowStateButton from "@/components/header/WorkflowStateButton.vue";
import IButton from "@/components/buttons/IButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { RootGetters } from "@/store/getters";
import Insights from "@/modules/insights/Insights.vue";
import { RootActions } from "@/store/actions";
import IbIcons from "@/components/icons/ib-icons.vue";
import { inputElements } from "@/core/utils"

declare const window: any;

export default defineComponent({
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  components: {
    PreferencesPanel,
    WorkflowStateButton,
    Insights,
    IButton,
    IbIcons,
  },
  data() {
    return {
      showPreferences: false as boolean,
    };
  },
  computed: {
    ...mapState(["loggedInUserName"]),
    ...mapGetters({
      isFirstRead: RootGetters.IS_FIRST_READ,
      isDirectLink: RootGetters.GET_IS_DIRECT_LINK,
      activeSlide: RootGetters.ACTIVE_SLIDE,
      slideById: RootGetters.GET_SLIDE_BY_ID,
      activeCase: RootGetters.GET_ACTIVE_CASE,
      hasActiveCase: RootGetters.HAS_ACTIVE_CASE,
      incompleteCasesCount: RootGetters.INCOMPLETE_CASES_COUNT,
    }),
    isSlideStatusButtonDisplayed(): boolean {
      return this.isFirstRead && this.activeSlide && this.activeSlide.workflowState;
    },
    state() {
      return {
        researchUse: this.$store.state.config.reaserch_use,
        currentSlide: this.$store.state.currentSlide,
      };
    },
  },
  methods: {
    ...mapActions({
      toggleCaseReport: RootActions.TOGGLE_CASE_REPORT,
    }),
    togglePreferences() {
      this.showPreferences = !this.showPreferences;
    },
    handleKeysEvent(e: { key: string, target: any }) {
      if (inputElements.includes(e.target.tagName.toLowerCase())) {
        return;
      }
      switch (e.key) {
        case "c":
        case "C":
          this.toggleCaseReportModal();
      }
    },
    toggleCaseReportModal() {
      if (this.isFirstRead && this.hasActiveCase) {
        this.toggleCaseReport();
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeysEvent, false);
  },
  unmounted() {
    window.removeEventListener("keydown", this.handleKeysEvent, false);
  },
});
